import { lazy } from 'react';

import { RoutePath } from '@/utils/enums';

const Dashboard = lazy(() => import('@/pages/Dashboard'));
const MarketActivity = lazy(
  () => import('@/pages/marketActivity/MarketActivity')
);
const MarketDepth = lazy(() => import('@/pages/marketDepth/MarketDepth'));
const ProjectDetails = lazy(() => import('@/pages/project/ProjectDetails'));
const AdminUsers = lazy(() => import('@/pages/admin/AdminUsers'));
const AdminNewUser = lazy(() => import('@/pages/admin/AdminNewUser'));
const AdminEditUser = lazy(() => import('@/pages/admin/AdminEditUser'));
const AdminCompanyNew = lazy(() => import('@/pages/admin/AdminCompanyNew'));
const AdminCompanyEdit = lazy(() => import('@/pages/admin/AdminCompanyEdit'));
const AdminRoles = lazy(() => import('@/pages/admin/AdminRoles'));
const AdminAudit = lazy(() => import('@/pages/admin/AdminAudit'));
const AdminBlockTrade = lazy(() => import('@/pages/admin/AdminBlockTrade'));
const AdminKeyMetrics = lazy(() => import('@/pages/admin/AdminKeyMetrics'));
const AdminCompanies = lazy(() => import('@/pages/admin/AdminCompanies'));
const AdminPackages = lazy(() => import('@/pages/admin/AdminPackages'));
const AdminFieldLibrary = lazy(() => import('@/pages/admin/AdminFieldLibrary'));
const AdminMarketReport = lazy(() => import('@/pages/admin/AdminMarketReport'));
const AdminCompanyDetails = lazy(
  () => import('@/pages/admin/AdminCompanyDetails')
);
const AdminCompanyAssign = lazy(
  () => import('@/pages/admin/AdminCompanyAssign')
);
const AdminCompanyAssignAdvisor = lazy(
  () => import('@/pages/admin/AdminCompanyAssignAdvisor')
);
const AdminLayout = lazy(() => import('@/pages/admin/AdminLayout'));
const SettingsAccount = lazy(() => import('@/pages/settings/SettingsAccount'));
const SettingsCompanyInformation = lazy(
  () => import('@/pages/settings/SettingsCompanyInformation')
);
const SettingsAlerts = lazy(() => import('@/pages/settings/SettingsAlerts'));
const SettingsLayout = lazy(() => import('@/pages/settings/SettingsLayout'));
const Transactions = lazy(() => import('@/pages/transactions/Transactions'));
const Actions = lazy(() => import('@/pages/Actions'));
const SigningComplete = lazy(
  () => import('@/pages/contracting/SigningComplete')
);

export const ASSIGN = 'assign';
export const NEW_USER = 'newUser';
export const EDIT_USER = 'editUser';
export const EDIT = 'edit';
export const ASSIGN_ADVISOR = 'assignAdvisor';

export const routes = {
  protected: [
    { path: RoutePath.ACTIONS, element: Actions },
    { path: RoutePath.DASHBOARD, element: Dashboard },
    { path: RoutePath.MARKET_ACTIVITY, element: MarketActivity },
    { path: RoutePath.MARKET_DEPTH, element: MarketDepth },
    { path: RoutePath.TRANSACTIONS, element: Transactions },
    { path: RoutePath.SIGNING_COMPLETE, element: SigningComplete },
    { path: `${RoutePath.PROJECT}/:id`, element: ProjectDetails },
  ],
  admin: {
    layout: AdminLayout,
    routes: [
      { path: 'roles', element: AdminRoles },
      { path: 'companies', element: AdminCompanies },
      { path: 'company/:id', element: AdminCompanyDetails },
      { path: `company/:id/${ASSIGN}`, element: AdminCompanyAssign },
      { path: `company/:id/${NEW_USER}`, element: AdminNewUser },
      { path: `company/:id/${EDIT_USER}/:userId`, element: AdminEditUser },
    ],
  },
  superAdmin: [
    { path: 'users', element: AdminUsers },
    { path: 'users/new', element: AdminNewUser },
    { path: `users/:userId/${EDIT}`, element: AdminEditUser },
    { path: 'company/new', element: AdminCompanyNew },
    { path: `company/:id/${EDIT}`, element: AdminCompanyEdit },
    {
      path: `company/:id/${ASSIGN_ADVISOR}`,
      element: AdminCompanyAssignAdvisor,
    },
    { path: 'audit', element: AdminAudit },
    // Note: blocktrade requires platform admin (not just super user).
    // It lives in the superAdmin array because SuperUserGuard is the closest
    // available route-level guard. The page component performs an additional
    // isPlatformAdmin check and redirects non-platform-admin users.
    // If more platform-admin-only routes are added, consider creating a
    // dedicated PlatformAdminGuard and route group.
    { path: 'blocktrade', element: AdminBlockTrade },
    { path: 'key-metrics', element: AdminKeyMetrics },
  ],
  platformAdmin: [
    { path: 'packages', element: AdminPackages },
    { path: 'fieldlibrary', element: AdminFieldLibrary },
    { path: 'market-report', element: AdminMarketReport },
  ],
  settings: {
    layout: SettingsLayout,
    routes: [
      { path: 'account', element: SettingsAccount },
      { path: 'company', element: SettingsCompanyInformation },
      { path: 'alerts', element: SettingsAlerts },
    ],
  },
};
